module.exports = "/packs/images/autism_icon~33b56740905ecdb302385ef662364076.jpg";